import React from "react";
import { Box, DialogTitle, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

interface DialogHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  onClose: () => void;
  closeDisabled?: boolean;
}

const DialogHeader: React.FC<DialogHeaderProps> = ({
  title,
  subtitle,
  icon,
  onClose,
  closeDisabled,
}) => (
  <DialogTitle sx={{ px: { xs: 2, sm: 3 }, py: { xs: 1.5, sm: 2 } }}>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          minWidth: 0,
          flex: 1,
        }}
      >
        {icon}
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              lineHeight: subtitle ? 1.2 : undefined,
              fontSize: { xs: "1.05rem", sm: "1.25rem" },
              wordBreak: "break-word",
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", wordBreak: "break-word" }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      <IconButton
        onClick={onClose}
        size="small"
        disabled={closeDisabled}
        sx={{ flexShrink: 0 }}
      >
        <Close />
      </IconButton>
    </Box>
  </DialogTitle>
);

export default DialogHeader;
